import type {
  QuoteManagementRecordModel,
  QuoteOrderSummaryModel,
} from './quoteMapper';

export const customerLinkStatusLabels = {
  unshared: '未分享',
  active: '有效',
  disabled: '已停用',
  expired: '已过期',
  revoked: '已撤销',
} as const;

export function quoteManagementSummary(record: QuoteManagementRecordModel) {
  return {
    versionLabel: record.currentCustomerShare
      ? `V${record.currentCustomerShare.customerVersionNo}`
      : '未分享',
    amountYuan:
      record.currentShareAmount === null
        ? null
        : record.currentShareAmount.totalCents / 100,
    statusLabel: customerLinkStatusLabels[record.customerLinkStatus],
    status: record.customerLinkStatus,
    statusColor:
      record.customerLinkStatus === 'active'
        ? 'green'
        : record.customerLinkStatus === 'disabled'
          ? 'orange'
          : record.customerLinkStatus === 'expired' ||
              record.customerLinkStatus === 'revoked'
            ? 'red'
            : undefined,
  };
}

export const CONFIRMED_QUOTE_READONLY_MESSAGE =
  '此报价已确认下单，原报价只读；如需修改，请复制为新报价。';

export const quoteBusinessStatusLabels = {
  QUOTING: '报价中',
  ORDER_PROCESSING: '下单处理中',
  ORDER_FAILED: '下单失败',
  ORDERED: '已下单',
} as const;

export function quoteBusinessSummary(record: QuoteOrderSummaryModel) {
  return {
    label: quoteBusinessStatusLabels[record.businessStatus],
    color:
      record.businessStatus === 'ORDERED'
        ? 'green'
        : record.businessStatus === 'ORDER_FAILED'
          ? 'red'
          : record.businessStatus === 'ORDER_PROCESSING'
            ? 'processing'
            : undefined,
    deliveryLabel:
      record.businessStatus === 'ORDER_PROCESSING'
        ? record.deliveryStatus === 'RUNNING'
          ? '发送中'
          : record.deliveryStatus === 'QUEUED'
            ? '待发送'
            : undefined
        : undefined,
  };
}
